module.exports = __webpack_public_path__ + "static/media/img39.f1f08b29.jpg";